<script lang="ts">
  import { onMount } from "svelte";
  import CountUpStatItem from "$lib/molecules/CountUpStatItem.svelte";

  // Define the delivery stats data
  interface DeliveryStats {
    num_deliveries: number;
  }

  // Fetch the delivery stats
  let deliveryStats = {} as DeliveryStats;
  let deliveryStatsLoaded = false;

  async function getStats() {
    try {
      const response = await fetch(
        "https://delivery-counter.platform.flyzipline.com/api/v1/public/stats/",
      );
      deliveryStats = await response.json();
      deliveryStatsLoaded = true;
    } catch (error) {
      console.error("Error fetching delivery stats:", error);
    }
  }

  onMount(() => {
    getStats();
  });
</script>

{#if deliveryStatsLoaded}
  <CountUpStatItem value={deliveryStats.num_deliveries} />
{/if}
